import { defineMessages } from '@formatjs/intl';

export default defineMessages({
	loginFaqCopy: {
		id: 'partner.account.login_faq_copy',
		defaultMessage: 'Log in to see if your Calm account is eligible for this offer.',
		description: 'Account faq',
	},
	faq: {
		id: 'partner.account.faq.short',
		defaultMessage: 'For more information, <faqtext>read our FAQ</faqtext>.',
		description: 'Account faq',
	},
});
